// extracted by mini-css-extract-plugin
export default {"image":"style_image__bitRJ","primaryImg":"style_primaryImg__KRHTt","options":"style_options__Llxr0"};